<template>
    <div class="video">
        <!-- 视频管理 -->
        <div class="video-top">
            <span>
                <img src="../../assets/img/home-icon.png" alt="" class="home-icon-img">
                <router-link :to="{ name: 'home' }">首页</router-link>
            </span>&nbsp;/&nbsp;
            <span>
                视频管理
            </span>
            <el-button icon="el-icon-back" class="retrunbtn" type="text" @click="urlback">返回</el-button>
        </div>
        <div class="video-content">
            <div class="video-content-search">
                <span class="video-search-title">任务名称: </span>
                <el-input v-model="taskname" class="video-search-input"></el-input>
                <span class="video-search-title">关联产品: </span>
                <el-select v-model="product_id" placeholder="" class="video-relevancy">
                    <el-option v-for="item in products" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <span class="video-search-title">状态: </span>
                <el-select v-model="state" placeholder="" class="video-relevancy">
                    <el-option v-for="item in states" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-button icon="el-icon-search" class="video-search-btn" @click="searchHandle">搜索</el-button>
            </div>
        </div>
        <!--  -->
        <div v-loading="loading" class="video-list item-list">
            <div class="video-item" v-for="item in videoData" :key="item.id">
                <div class="video-item-left">
                    <el-checkbox v-model="item.chk"></el-checkbox>
                    <div class="video-img-box">
                        <img :src="resize(item.cover)" alt="" class="video-item-img" v-if="item.cover">
                        <img src="../../assets/img/默认封面.png" alt="" class="video-item-img" v-else>
                    </div>
                    <div class="video-item-left-text">
                        <el-tooltip class="box-item" effect="dark" :content="item.name" placement="right">
                            <p><span class="video-item-title">名&nbsp;&nbsp;&nbsp;称: </span><span class="video-item-data"
                                    alt="tem.name">{{
                                        item.name
                                    }}</span>
                            </p>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark" :content="item.title1" placement="right">
                            <p>
                                <span class="video-item-title">主标题: </span><span class="video-item-data">{{ item.title1
                                }}</span>
                            </p>
                        </el-tooltip>
                    </div>
                    <div class="video-item-left-text">
                        <el-tooltip class="box-item" effect="dark" :content="item.task_name" placement="right">
                            <p><span class="video-item-title">任务名称: </span><span class="video-item-data">{{ item.task_name
                            }}</span></p>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark" :content="item.create_time" placement="right"
                            v-if="item.create_time">
                            <p><span class="video-item-title">开始时间: </span><span class="video-item-data">{{ item.create_time
                            }}</span></p>
                        </el-tooltip>
                        <p v-else></p>
                    </div>
                    <div class="video-item-left-text">
                        <el-tooltip class="box-item" effect="dark" :content="item.product_name" placement="right">
                            <p><span class="video-item-title">关联产品: </span><span class="video-item-data">{{
                                item.product_name
                            }}</span>
                            </p>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark" :content="item.finish_time" placement="right"
                            v-if="item.finish_time">
                            <p><span class="video-item-title">完成时间: </span><span class="video-item-data">{{ item.finish_time
                            }}</span></p>
                        </el-tooltip>
                        <p v-else></p>
                    </div>
                </div>
                <div class="video-item-right">
                    <!-- <el-button type="text" class="video-item-particulars" @click="GetJson(item.pro_id)">
                        json
                    </el-button> -->
                    <span class="video-item-right-default" v-show="item.state == '未开始' ? true : false">未开始</span>
                    <span class="video-item-right-finish" v-show="item.state == '进行中' ? true : false">进行中</span>
                    <span class="video-item-right-default" v-show="item.state == '已删除' ? true : false">已删除</span>
                    <!-- 已完成 -->
                    <template v-if="item.state == '已完成' ? true : false">
                        <el-button type="text" class="video-item-particulars" @click="preview(item)">
                            预览
                        </el-button>
                        <span class="video-item-right-execute">已完成</span>
                    </template>
                    <!-- 出错 -->
                    <el-tooltip effect="dark" :content="item.msg" placement="right">
                        <span class="video-item-right-execute" v-show="item.state == '出错' ? true : false"
                            style="cursor: pointer">出错</span>
                    </el-tooltip>

                </div>
            </div>
        </div>

        <!--  -->
        <div class="video-bottom item-bottom">
            <div class="video-bottom-left">
                <el-checkbox v-model="checkAll">全选</el-checkbox>

                <el-button class="video-del-btn" @click="downloads">下 载</el-button>
                <el-button class="video-del-btn" @click="restarts">错误重置</el-button>
                <el-button class="video-del-btn" @click="deletes">删 除</el-button>
            </div>
            <el-pagination @current-change="handleCurrentChange" :current-page="current" :page-size="pageSize"
                layout="total, prev, pager, next" :total="total">
            </el-pagination>
        </div>

        <!-- 发布平台弹框 -->
        <div>
            <el-dialog title="发布平台" class="video-publish-dialog" :visible.sync="videoPublishDialog" width="390px"
                :close-on-click-modal="false" top="24vh">
                <el-form v-model="publishData" :rules="publishRules" label-width="60px" class="video-publish-form">
                    <el-form-item label="标题" prop="titleVale">
                        <el-input v-model="publishData.titleVale" placeholder="请输入标题"></el-input>
                    </el-form-item>
                    <el-form-item label="平台" prop="publish">
                        <div>
                            <el-checkbox-group v-model="checkAllDialog" class="checkbox-group-box">
                                <div class="video-publish-item" v-for="item in publishData.publish" :key="item.id">
                                    <div class="video-publish-item-left">
                                        <div class="video-publish-item-img">
                                            <img src="../../assets/img/video-img.png" alt="">
                                        </div>
                                        <span class="video-publish-item-title">{{ item.title }}</span>
                                    </div>
                                    <div class="video-publish-item-right">
                                        <el-checkbox :label="item.id"></el-checkbox>
                                    </div>
                                </div>
                            </el-checkbox-group>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="form-bottom-box">
                    <el-button class="video-cancel-btn" @click="videoPublishDialog = false">取消</el-button>
                    <el-button class="video-publish-btn" @click="publishDialogHandle">发布</el-button>
                </div>
            </el-dialog>
        </div>

        <el-dialog :title="preview_name" :visible.sync="preview_dialog">
            <div class="preview_div">
                <video :src="preview_url" controls autoplay></video>
            </div>
            <span slot="footer">
                <el-button type="primary" @click="downitem" :loading="preview_downing">下载</el-button>
                <el-button @click="restart">重 置</el-button>
                <el-button @click="preview_dialog = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import { stringify } from 'querystring';
import Video from '../../views/Video.vue';
import { resize } from '../../assets/js/common';
export default {
    components: { Video },
    name: 'videoPage',
    data() {
        return {
            // 数据
            videoData: [],
            // 弹框
            videoPublishDialog: false,
            // 弹框平台数据
            publishData: {
                titleVale: '',
                publish: [
                    {
                        id: 1,
                        title: '抖音平台01',
                    },
                    {
                        id: 2,
                        title: '抖音平台02',
                    },
                    {
                        id: 3,
                        title: '抖音平台03',
                    }
                ],
            },
            // 弹框选择
            checkAllDialog: [],
            // 表单验证
            publishRules: {
                titleVale: [
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ],
                publish: [
                    { required: true, message: '请选择发布平台', trigger: 'blur' }
                ]
            },
            // 分页
            current: 1,
            pageSize: 50,
            total: 0,
            productid: 0,
            pid: 0,
            state: 0,
            states: [{
                label: "全部",
                value: 0
            },
            {
                label: "未开始",
                value: -1
            },
            {
                label: "进行中",
                value: 1
            }, {
                label: "已完成",
                value: 100
            }, {
                label: "已取消",
                value: 1001
            }, {
                label: "出错",
                value: 1002
            }, {
                label: "已删除",
                value: 1003
            }],
            taskname: '',
            product_id: 0,
            products: [],

            preview_id: 0,
            preview_dialog: false,
            preview_url: '',
            preview_name: '',
            preview_downing: false
        }
    },
    created() {
        var query = this.$route.query;
        this.pid = query.pid;
        this.taskname = query.taskname;
        this.$get('/product/options?type=0').then(res => {
            this.products = res.data;
        })

        if (this.pid) {
            this.product_id = Number(this.pid)
        }
        this.query();
    },
    methods: {
        resize(url) {
            return resize(url)
        },
        // 分页
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.current = val;
            this.query();
        },
        // 搜索
        searchHandle() {
            this.current = 1;
            this.query();
        },
        // 发布
        publishHandle() {
            this.videoPublishDialog = true
        },
        // 弹窗发布
        publishDialogHandle() {
            this.videoPublishDialog = false
        },
        query() {
            this.loading = true;
            this.$get('/video/list', {
                page: this.current,
                size: this.pageSize,
                state: this.state,
                product_id: this.product_id,
                taskname: this.taskname,
            }).then(res => {
                for (let i in res.data.data) {
                    res.data.data[i].chk = false;
                }
                this.videoData = res.data.data;
                this.total = res.data.total;
                this.loading = false;
            })
        },
        urlback() {
            this.$router.go(-1);
        },
        preview(row) {
            if (row.url == '') {
                this.$message.error("预览失败：没有获取到视频地址");
                return;
            }
            this.preview_dialog = true;
            this.preview_id = row.pro_id;
            this.preview_url = row.url;
            this.preview_name = row.name;
        },
        //单个下载
        downitem() {
            this.openUrl('/down', { url: this.preview_url, name: this.preview_name + '.mp4' })
            // this.preview_downing = true;
            // this.$download(this.preview_url, this.preview_name + '.mp4')
            //     .catch(res => {
            //         this.$message.error("下载失败")
            //     }).finally(res => {
            //         this.preview_downing = false;
            //     });

        },
        // 批量下载
        downloads() {
            let rows = this.$linq.from(this.videoData).where(w => w.chk == true && w.state == '已完成').toArray();
            if (rows.length == 0) { return; }
            let tip = this.$message.success("正在后台下载，稍等片刻")
            for (let i in rows) {
                this.openUrl('/down', { url: rows[i].url, name: rows[i].name + '.mp4' })
                // console.log(rows[i]);
                // this.$download(rows[i].url, rows[i].name + '.mp4')
                //     .catch(res => {
                //         this.$message.closeAll();
                //         this.$message.error(rows[i].name + "下载失败")
                //     }).finally(res => {

                //     });
            }
        },
        //批量重置
        restarts() {
            let rows = this.$linq.from(this.videoData).where(w => w.chk == true && w.state != '已完成').select(s => s.pro_id).toArray();
            if (rows.length == 0) {
                this.$message.warning("请选择合成失败的视频"); return;
            }

            // this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.$message({
            //         type: 'success',
            //         message: '删除成功!'
            //     });
            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '已取消删除'
            //     });
            // });

            this.$confirm('确认重置任务？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.$post('/video/operation', { ids: rows, video_state: -1 }).then(res => {
                    if (res.code == 200) {
                        this.$message.success("已重置");
                        this.query();
                    } else {
                        this.$message.error(res.msg);
                    }

                })
            })
        },

        //重置
        restart() {
            this.$confirm('确认重置任务？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(res => {
                this.$post('/video/operation', { ids: [this.preview_id], video_state: -1 }).then(res => {
                    if (res.code == 200) {
                        this.$message.success("已重置");
                        this.preview_dialog = false;
                        this.query();
                    } else {
                        this.$message.error(res.msg);
                    }

                })
            })
        },
        deletes() {
            let rows = this.$linq.from(this.videoData).where(w => w.chk == true).select(s => s.pro_id).toArray();
            if (rows.length == 0) {
                this.$message.warning("请先选择要删除的视频"); return;
            }
            this.$confirm('确认删除任务？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(res => {
                this.$post('/video/operation', { ids: rows, video_state: 1003 }).then(res => {
                    if (res.code == 200) {
                        this.$message.success("已删除");
                        this.query();
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            })
        },
        //查看配置json
        GetJson(id) {
            this.$get('/video/json', { id: id }).then(res => {
                this.$alert(res.data, '视频配置', {
                    confirmButtonText: '确定'
                });
            })
        },
        openUrl(router, params) {
            let url = router + "?" + new URLSearchParams(params).toString();
            window.open(url);
        },
    },
    computed: {
        // 全选
        checkAll: {
            set(v) {
                // console.log(v)
                this.videoData.forEach((item) => (item.chk = v))
            },
            get() {
                return this.videoData.every((item) => item.chk)
            }
        }
    }
}

</script>
<style scoped>
.video-top {
    width: 100%;
    height: 50px;
    background-color: #fff;
    border-radius: 3px;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding: 16px 20px;
}

.video-top {
    color: #606266;
    font-size: 14px;
}

.video-top .home-icon-img {
    margin-right: 4px;
}

.video-top a {
    color: #606266;
}

.video-top a:hover {
    color: #006cff;
}

.video-content {
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 20px;
}

/*  */
.video-content-search {
    box-sizing: border-box;
    padding: 16px 0;
}

.video-search-title {
    font-size: 14px;
    color: #333;
}

.video-search-input {
    width: 200px;
    height: 40px;
    margin-right: 10px;
}

.video-search-input input {
    background-color: #fff;
    border: 1px solid #d9dde5;
    border-radius: 3px;
}

.video-relevancy {
    width: 200px;
    height: 40px;
    margin-right: 10px;
}

.video-search-btn {
    width: 80px;
    height: 40px;
    background-color: #006cff !important;
    border-radius: 3px;
    padding: 0;
    border: none;
    color: #fff !important;
    opacity: 1;
    transition: all 0.2s ease;
}

.video-search-btn:hover {
    opacity: 0.9;
}

/*  */
.video-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 3px;
    padding: 20px;
    margin-top: 10px;
}

.video-item-left {
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 修改 */
.video-item-img {
    max-width: 100%;
    display: block;
    max-height: 60px;
}

.video-item-title {
    color: #888;
    font-size: 13px;
    white-space: nowrap;
}

.video-item-data {
    color: #000;
    font-size: 14px;
    white-space: nowrap;

}

/* 修改 */
.video-item-left-text {
    margin-right: 20px;
}

.video-item-left-text p {
    height: 20px;
    width: 178px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.video-item-left-text p:first-child {
    margin-bottom: 4px;
}

.video-item-left div:nth-child(2) {
    /* width: 200px; */
}

.video-item-left div:nth-child(3) {
    width: 180px;
}

.video-item-right {
    display: flex;
    align-items: center;
}

/* 修改完成和未完成颜色 */
.video-item-right .video-item-right-default {
    color: #888;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    white-space: nowrap;
}

.video-item-right .video-item-right-default::before {
    content: '';
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #888;
    margin-right: 3px;
}

.video-item-right .video-item-right-execute {
    color: #0db46e;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    white-space: nowrap;
}

.video-item-right .video-item-right-execute::before {
    content: '';
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #0db46e;
    margin-right: 3px;
}

.video-item-right .video-item-right-finish {
    color: #ffa72e;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    white-space: nowrap;
}

.video-item-right .video-item-right-finish::before {
    content: '';
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #ffa72e;
    margin-right: 3px;
}

.video-item-particulars {
    color: #006cff;
    font-size: 14px;
    padding: 0;
    margin-right: 20px;
}

/*  */
.video-bottom {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    box-sizing: border-box;
    padding: 10px 15px;
}

.video-bottom .el-pagination {
    color: #606266;
    font-weight: 400;
}

.video-bottom .el-pagination>>>button {
    border: 1px solid #d9d9d9 !important;
    border-radius: 3px;
    padding: 0;
    min-width: 28px !important;
}

.video-bottom .el-pagination .btn-next,
.el-pagination .btn-prev {
    background: center center no-repeat #FFF;
    background-size: 16px;
    cursor: pointer;
    margin: 0;
    color: #606266;
}

.video-bottom .el-pagination .el-select .el-input {
    width: 90px;
    margin: 0 5px;
}

.video-bottom .el-pagination>>>.el-pagination__jump {
    margin-left: 10px;
    font-weight: 400;
    color: #606266;
}

.video-del-btn {
    width: 74px;
    height: 32px;
    border: 1px solid #d9d9d9;
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.09);
    padding: 0;
    margin-left: 10px;
}

.video-bottom-left {
    margin-left: 14px;
}

.video-bottom-left>>>.el-checkbox__label {
    padding-left: 20px;
}

.video-publish-dialog>>>.el-dialog__header {
    padding: 16px 18px;
    border-bottom: 1px solid #eee;
}

.video-publish-dialog>>>.el-dialog__title {
    font-size: 15px;
    color: #333;
}

.video-publish-dialog>>>.el-dialog__body {
    padding: 20px 0;
    padding-bottom: 0px;
}

.video-publish-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
}

.video-publish-item .video-publish-item-left {
    display: flex;
    align-items: center;
}

.video-publish-item-img {
    width: 45px;
    height: 45px;
    border-radius: 3px;
    margin-right: 18px;
}

.video-publish-item-img img {
    width: 100%;
}

.video-publish-item-title {
    font-size: 14px;
    color: #333;
}

.video-publish-item>>>.el-checkbox__label {
    display: none;
}

.video-publish-form {
    box-sizing: border-box;
    padding-right: 20px;
}

.form-bottom-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #eee;
    box-sizing: border-box;
    padding: 18px 0;
}

.video-cancel-btn {
    width: 74px;
    height: 36px;
    border: 1px solid #d9dde5;
    border-radius: 3px;
    font-size: 14px;
    color: #606266;
    padding: 0;
}

.video-publish-btn {
    width: 120px;
    height: 36px;
    background-color: #006cff;
    border: none;
    padding: 0;
    font-size: 14px;
    color: #fff;
}

.video-publish-item-right>>>.el-checkbox__inner {
    width: 14px;
    height: 14px;
    border: 1px solid #006cff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.video-publish-item-right>>>.is-checked .el-checkbox__inner::after {
    content: '';
    width: 8px;
    height: 8px;
    background-color: #006cff;
    border-radius: 50%;
    border: 0;
    position: static;
}

.video-publish-item-right>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.video-publish-item-right>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #fff;
}

.video-item>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.video-item>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #006CFF;
    border-color: #006CFF;
}

.video-bottom>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.video-bottom>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #006CFF;
    border-color: #006CFF;
}

@media screen and (max-width:1024px) {
    .video-item-left-text {
        margin-right: 25px;
    }

    .video-search-input {
        width: 170px;
    }

    .video-relevancy {
        width: 170px;
    }

    .video-search-btn {
        margin-top: 10px;
    }

    .video-bottom {
        flex-wrap: wrap;
    }

    .video-bottom-left {
        margin-bottom: 10px;
    }

    .el-pagination {
        margin-left: 14px;
    }
}

/* 修改 */
.video-img-box {
    width: 100px;
    border-radius: 3px;
    margin: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.video-list {

    height: calc(100vh - 300px);
}

.preview_div video {
    width: 100%;
    height: 100%;
    max-height: 480px;
    background-color: black;
}



.video::-webkit-scrollbar {
    display: none;
}

/* @media screen and (max-width:1250px) {
  .video-list{
    height: 490px;
  }
} */
</style>
